var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayMaya(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 21,
    viewBox: "0 0 34 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 21,
    rx: 1.5,
    style: {
      fill: "#00334d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.63 8.43a4 4 0 0 1 2.7.65 8.6 8.6 0 0 1 2.9 3.34 20.35 20.35 0 0 1 1.69 4.48c0 .2.14.42 0 .62s-.26.15-.41.15a21.86 21.86 0 0 1-4.2-.19 10.35 10.35 0 0 1-3-.95A5.72 5.72 0 0 1 21.42 15a4.73 4.73 0 0 1-1.1-2.78 4.16 4.16 0 0 1 .81-2.42 3.78 3.78 0 0 1 2.5-1.37z",
    transform: "translate(-5.5 -4.5)",
    style: {
      fill: "#92c83e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.49 10.14a2.32 2.32 0 0 1 .46 0c.13.05 0 .21 0 .3a4.15 4.15 0 0 0-.24 3 6.05 6.05 0 0 0 2.19 3.15 8.6 8.6 0 0 0 2.76 1.33 16.64 16.64 0 0 0 3.57.59.34.34 0 0 1 .33.19c.33.9.6 1.83.84 2.76a.54.54 0 0 1 0 .45c-.1.14-.3.11-.45.12-1.14 0-2.28-.07-3.42-.16a18 18 0 0 1-4.6-.92 9.51 9.51 0 0 1-4.2-2.72 5.78 5.78 0 0 1-1.4-3.44 4.39 4.39 0 0 1 1.14-3.05 4.82 4.82 0 0 1 3.02-1.6z",
    transform: "translate(-5.5 -4.5)",
    style: {
      fill: "#0083cb"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayMaya);
export default __webpack_public_path__ + "static/media/PayMaya.4070ec9e.svg";
export { ForwardRef as ReactComponent };